export default "assets/images/flags/be-60a5bea9.svg";